<template>
    <Carousel class="" :perPage="perPage" :autoplay="autoplay" :autoplayHoverPause="autoplayHoverPause" :loop="loop" :paginationEnabled="paginationEnabled" :autoplayTimeout="autoplayTimeout">
        <Slide class="slide" v-for="pic in pics" :key="pic">
         <img class="image w-100" :src="pic"/>
     </Slide>
 </Carousel>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
    name: 'carousel',
    data () {
        return {
            perPage: 1,
            autoplay: true,
            autoplayTimeout: 10000,
            autoplayHoverPause: false,
            loop: true,
            paginationEnabled: false,
            pics: [
            'https://images.unsplash.com/photo-1481026469463-66327c86e544?auto=format&fit=crop&w=2908&q=80',
            'https://images.unsplash.com/photo-1493397212122-2b85dda8106b?auto=format&fit=crop&w=1651&q=80',
            'https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?auto=format&fit=crop&w=1650&q=80',
            // 'https://images.unsplash.com/photo-1460647927807-8e664765c97c?auto=format&fit=crop&w=2850&q=80'
            ]
        }
    },
    components: {
      Carousel,
      Slide
    },
    methods: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.image {
    height: 88vh;
}
</style>



// WEBPACK FOOTER //
// src/components/Carousel.vue